import './offer.css';
import Logo from '../../header/images/logo.png';

import { useLocation } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentForm from './StripePaymentForm';

import MenuPlans from './MenuPlans';




const stripePromise = loadStripe('pk_test_51QCzkaLrf6T4kadVTAELgxuBtSPTl627X2CC1gSrFzfdWJzvzJDFJYJ9ADCmgdLCUTETDzucrPNWgqpxwZfDt62Z00c0IRXBRv');

const Paymentpage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const plan = params.get('plan') || 'annual';
  // Sume hardcodate pentru test: 70 lei/lună, 550 lei/an
  const amount = plan === 'monthly' ? 7000 : 55000;
  return (
    <>
    
    <MenuPlans />
    
   
    <div className='cadru-premium-step-two'>
    
      <div className='info-cadru-premium'>
        <div className='w-100'>
          <div className='header-premuim-page'>
            <h1>Detalii de plata</h1>
          </div>
          <Elements stripe={stripePromise}>
            <StripePaymentForm amount={amount} />
          </Elements>
        </div>
      </div>
    </div>

     </>
  );
};

export default Paymentpage;